import { selectCurrentAccount } from 'app/store/Accounts/Accounts.selectors';
import { useAppSelector } from './useStore';
import AccountStatuses from 'app/types/AccountStatuses';

const useAccountStatus = () => {
  const currentAccount = useAppSelector(selectCurrentAccount);

  const isSuspended = currentAccount?.status === AccountStatuses.Suspended;

  return { isSuspended };
}

export default useAccountStatus;
